import styled from 'styled-components';

export const Badge = styled.div`
  width: min-content;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.neutral[50]};
  border: 1px solid ${({ theme }) => theme.colors.neutral[100]};
  border-radius: 23px;
  padding: 4px 8px;
  gap: 4px;

  span {
    max-width: 260px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
